import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { IPopupProps } from '../Popup'

import { PrimarySubmitButton } from 'atoms/Button/Templates'
import { TextBoxBody2 } from 'atoms/TextBox/Templates'
import { PopupTitleWithCounter } from 'blocks/TextBlock/Templates'
import { Popup } from '../Popup'
import { PopupPaddings, PopupRowGap } from '../Popup.h'

export interface IAnnouncementPopupProps extends Omit<IPopupProps, 'children'> {
  counter: ITextBoxProps['title']
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
  buttonText: ITextBoxProps['title']
  buttonDisabled?: boolean
  onSubmit?: () => void
}

export const AnnouncementPopup = ({
  width = '520px',
  padding = PopupPaddings.SIZE_50,
  rowGap = PopupRowGap.INDENT_40,
  counter,
  title,
  description,
  buttonText,
  buttonDisabled = false,
  onSubmit,
  hasCloseOnClickOverlay = false,
  ...rest
}: IAnnouncementPopupProps): JSX.Element => (
  <Popup
    width={width}
    padding={padding}
    rowGap={rowGap}
    hasCloseOnClickOverlay={hasCloseOnClickOverlay}
    {...rest}
  >
    <PopupTitleWithCounter title={title} counter={counter} />
    <TextBoxBody2 title={description} />
    <PrimarySubmitButton
      title={buttonText}
      disabled={buttonDisabled}
      onClick={onSubmit}
    />
  </Popup>
)
